<template>
    <div id="add-loonlakwerk-page">
        <div class="top-buttons">
            <ui5-button
                @click="save(null)"
                :disabled="loading || saving"
            >
                <spinner v-if="saving" />
                {{ trans('pages.add_loonlakwerk.save') }}
            </ui5-button>
            <ui5-button @click="$router.push('/stockcount')">
                {{ trans('pages.add_loonlakwerk.cancel') }}
            </ui5-button>
        </div>

        <spinner-text v-if="loading">
            {{ trans('pages.add_loonlakwerk.loading') }}
        </spinner-text>
        <div v-show="!loading">
            <div
                class="field"
                id="editLoonlakwerkcode"
            >
                <ui5-label for="code">
                    {{ trans('pages.add_loonlakwerk.art_nr') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="code"
                    id="code"
                />
            </div>
            <div
                class="field"
                id="editLoonlakwerkprofilegroup"
            >
                <ui5-label for="loonlakwerkProfilegroup">
                    {{ trans('pages.add_loonlakwerk.group') }}
                </ui5-label>
                <ui5-select id="loonlakwerkProfilegroup">
                    <ui5-option></ui5-option>
                    <ui5-option
                        v-for="group in profileGroups"
                        :key="'group.' + group.profileGroupId"
                        :value="group.profileGroupId"
                    >
                        {{ group.name }}
                    </ui5-option>
                </ui5-select>
            </div>
            <div
                class="field"
                id="editLoonlakwerkprofilesubgroup"
            >
                <ui5-label for="loonlakwerkProfilesubgroup">
                    {{ trans('pages.add_loonlakwerk.subgroup') }}
                </ui5-label>
                <ui5-select id="loonlakwerkProfilesubgroup">
                    <ui5-option></ui5-option>
                    <ui5-option
                        v-for="group in profileSubgroups"
                        :key="'subgroup.' + group.profileGroupId"
                        :value="group.profileGroupId"
                    >
                        {{ group.name }}
                    </ui5-option>
                </ui5-select>
            </div>
            <div
                id="editLoonlakwerkprofilestockgroup"
                class="field"
                v-show="false"
            >
                <ui5-label for="profilestockgroup">
                    {{ trans('pages.add_loonlakwerk.stockgroup') }}
                </ui5-label>
                <ui5-select id="profilestockgroup" />
            </div>
            <div
                class="field"
                id="editLoonlakwerkprofilesupplier"
            >
                <ui5-label for="loonlakwerkProfilesupplier">
                    {{ trans('pages.add_loonlakwerk.supplier') }}
                </ui5-label>
                <ui5-select id="loonlakwerkProfilesupplier">
                    <ui5-option></ui5-option>
                    <ui5-option
                        v-for="supplier in suppliers"
                        :key="'supplier.' + supplier.id"
                        :value="supplier.id"
                    >
                        {{ supplier.name }}
                    </ui5-option>
                </ui5-select>
            </div>
            <div
                class="field"
                id="editLoonlakwerksupplierCode"
            >
                <ui5-label for="suppliercode">
                    {{ trans('pages.add_loonlakwerk.supplier_code') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="suppliercode"
                    id="suppliercode"
                />
            </div>
            <div
                class="field"
                id="editLoonlakwerksupplierProfileCode"
            >
                <ui5-label for="supplierProfileCode">
                    {{ trans('pages.add_loonlakwerk.supplier_profile_code') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="supplierProfileCode"
                    id="supplierProfileCode"
                />
            </div>
            <div
                class="field"
                id="editLoonlakwerkbarcode"
            >
                <ui5-label for="barcode">
                    {{ trans('pages.add_loonlakwerk.barcode') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="barcode"
                    id="barcode"
                />
            </div>
            <div
                class="field"
                id="editLoonlakwerkdescription"
            >
                <ui5-label for="description">
                    {{ trans('pages.add_loonlakwerk.description_nl') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="description"
                    id="description"
                />
            </div>
            <div
                class="field"
                id="editLoonlakwerkdescriptionFR"
            >
                <ui5-label for="descriptionFR">
                    {{ trans('pages.add_loonlakwerk.description_fr') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="descriptionFR"
                    id="descriptionFR"
                />
            </div>
            <div
                id="editLoonlakwerkinfo"
                class="field"
                v-show="false"
            >
                <ui5-label for="info">
                    {{ trans('pages.add_loonlakwerk.extra_info') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="info"
                    id="info"
                />
            </div>
            <div
                id="editLoonlakwerkweightBox"
                class="field"
                v-show="false"
            >
                <ui5-label for="weightBox">
                    {{ trans('pages.add_loonlakwerk.weight_package') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="weightBox"
                    id="weightBox"
                />
            </div>
            <div
                id="editLoonlakwerkweight"
                class="field"
                v-show="false"
            >
                <ui5-label for="weight">
                    {{ trans('pages.add_loonlakwerk.weight') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="weight"
                    id="weight"
                />
            </div>
            <div
                id="editLoonlakwerkcountPerKg"
                class="field"
                v-show="false"
            >
                <ui5-label for="countPerKg">
                    {{ trans('pages.add_loonlakwerk.count_per_kg') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="countPerKg"
                    id="countPerKg"
                />
            </div>
            <div
                id="editLoonlakwerkminStock"
                class="field"
                v-show="false"
            >
                <ui5-label for="minStock">
                    {{ trans('pages.add_loonlakwerk.min_stock') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="minStock"
                    id="minStock"
                />
            </div>
            <div
                id="editLoonlakwerkmaxStock"
                class="field"
                v-show="false"
            >
                <ui5-label for="maxStock">
                    {{ trans('pages.add_loonlakwerk.max_stock') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="maxStock"
                    id="maxStock"
                />
            </div>
            <div
                id="editLoonlakwerkcurrentstockcount"
                class="field"
                v-show="false"
            >
                <ui5-label for="currentstockcount">
                    {{ trans('pages.add_loonlakwerk.stock') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="currentstockcount"
                    id="currentstockcount"
                />
            </div>
            <div
                id="editLoonlakwerkprofileunit"
                class="field"
                v-show="false"
            >
                <ui5-label for="profileunit">
                    {{ trans('pages.add_loonlakwerk.unit') }}
                </ui5-label>
                <ui5-select id="profileunit" />
            </div>
            <div
                id="editLoonlakwerkpackagePerUnit"
                class="field"
                v-show="false"
            >
                <ui5-label for="packagePerUnit">
                    {{ trans('pages.add_loonlakwerk.package_per_unit') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="packagePerUnit"
                    id="packagePerUnit"
                />
            </div>
            <div
                id="editLoonlakwerkkeepStock"
                class="field"
                v-show="false"
            >
                <ui5-label for="keepStock">
                    {{ trans('pages.add_loonlakwerk.keep_stock') }}
                </ui5-label>
                <ui5-checkbox
                    name="keepStock"
                    id="keepStock"
                />
            </div>
            <div
                id="editLoonlakwerkcountsequence"
                class="field"
                v-show="false"
            >
                <ui5-label for="countsequence">
                    {{ trans('pages.add_loonlakwerk.count_sequence') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="countsequence"
                    id="countsequence"
                />
            </div>
            <div
                id="editLoonlakwerklocation"
                class="field"
                v-show="false"
            >
                <ui5-label for="location">
                    {{ trans('pages.add_loonlakwerk.rack') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="location"
                    id="location"
                />
            </div>
            <div
                id="editLoonlakwerklatestCount"
                class="field"
                v-show="false"
            >
                <ui5-label for="latestCount">
                    {{ trans('pages.add_loonlakwerk.latest_count') }}
                </ui5-label>
                <ui5-date-picker
                    id="latestCount"
                    format-pattern="dd-MM-yyyy"
                    readonly
                />
            </div>
            <div
                id="editLoonlakwerkbruto"
                class="field"
                v-show="false"
            >
                <ui5-label for="bruto">
                    {{ trans('pages.add_loonlakwerk.bruto_price') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="bruto"
                    id="bruto"
                />
            </div>
            <div
                id="editLoonlakwerknetto"
                class="field"
                v-show="false"
            >
                <ui5-label for="netto">
                    {{ trans('pages.add_loonlakwerk.netto_price') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="netto"
                    id="netto"
                />
            </div>
            <div
                id="editLoonlakwerkmmPrice"
                class="field"
                v-show="false"
            >
                <ui5-label for="mmPrice">
                    {{ trans('pages.add_loonlakwerk.mm_price') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="mmPrice"
                    id="mmPrice"
                />
            </div>
            <div
                id="editLoonlakwerkeosolPrice"
                class="field"
                v-show="false"
            >
                <ui5-label for="eosolPrice">
                    {{ trans('pages.add_loonlakwerk.eosol_price') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="eosolPrice"
                    id="eosolPrice"
                />
            </div>
            <div
                id="editLoonlakwerkeosolBuyPrice"
                class="field"
                v-show="false"
            >
                <ui5-label for="eosolBuyPrice">
                    {{ trans('pages.add_loonlakwerk.eosol_buy_price') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="eosolBuyPrice"
                    id="eosolBuyPrice"
                />
            </div>
            <div
                id="editLoonlakwerkprice4"
                class="field"
                v-show="false"
            >
                <ui5-label for="price4">
                    {{ trans('pages.add_loonlakwerk.price4') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="price4"
                    id="price4"
                />
            </div>
            <div
                id="editLoonlakwerklatestPriceControl"
                class="field"
                v-show="false"
            >
                <ui5-label for="latestPriceControl">
                    {{ trans('pages.add_loonlakwerk.latest_price_control') }}
                </ui5-label>
                <ui5-date-picker
                    id="latestPriceControl"
                    format-pattern="dd-MM-yyyy"
                    readonly
                />
            </div>
            <div
                id="editLoonlakwerkpricelist"
                class="field"
                v-show="false"
            >
                <ui5-label for="pricelist">
                    {{ trans('pages.add_loonlakwerk.pricelist') }}
                </ui5-label>
                <ui5-checkbox
                    name="pricelist"
                    id="pricelist"
                />
            </div>
            <div
                class="field"
                id="editLoonlakwerklength"
            >
                <ui5-label for="length">
                    {{ trans('pages.add_loonlakwerk.profile_length') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="length"
                    id="length"
                />
            </div>
            <div
                class="field"
                id="editLoonlakwerkwidth"
            >
                <ui5-label for="width">
                    {{ trans('pages.add_loonlakwerk.profile_width') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="width"
                    id="width"
                />
            </div>
            <div
                class="field"
                id="editLoonlakwerkheight"
            >
                <ui5-label for="height">
                    {{ trans('pages.add_loonlakwerk.profile_height') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="height"
                    id="height"
                />
            </div>
            <div
                class="field"
                id="editLoonlakwerkcontour"
            >
                <ui5-label for="contour">
                    {{ trans('pages.add_loonlakwerk.contour') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="contour"
                    id="contour"
                />
            </div>
            <div
                class="field"
                id="editLoonlakwerkcontour2"
            >
                <ui5-label for="contour2">
                    {{ trans('pages.add_loonlakwerk.contour2') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="contour2"
                    id="contour2"
                />
            </div>
            <div
                class="field"
                id="editLoonlakwerkweightLM"
            >
                <ui5-label for="weightLM">
                    {{ trans('pages.add_loonlakwerk.weight_lm') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="weightLM"
                    id="weightLM"
                />
            </div>

            <div
                id="editLoonlakwerklocation2"
                class="field"
                v-show="false"
            >
                <ui5-label for="stockLocation2">
                    {{ trans('pages.add_loonlakwerk.rack2') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="stockLocation2"
                    id="stockLocation2"
                />
            </div>

            <div
                id="editLoonlakwerkbinlocation"
                class="field"
                v-show="false"
            >
                <ui5-label for="binLocation">
                    {{ trans('pages.add_loonlakwerk.bin_location') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="binLocation"
                    id="binLocation"
                />
            </div>

            <div
                id="editLoonlakwerkdescriptionkanban"
                class="field"
                v-show="false"
            >
                <ui5-label for="descriptionKanban">
                    {{ trans('pages.add_loonlakwerk.description_kanban') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="descriptionKanban"
                    id="descriptionKanban"
                />
            </div>

            <div
                id="editLoonlakwerkdeliveryperiod"
                class="field"
                v-show="false"
            >
                <ui5-label for="deliveryPeriod">
                    {{ trans('pages.add_loonlakwerk.delivery_period') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="deliveryPeriod"
                    id="deliveryPeriod"
                />
            </div>

            <div
                id="editLoonlakwerksparestock"
                class="field"
                v-show="false"
            >
                <ui5-label for="spareStock">
                    {{ trans('pages.add_loonlakwerk.spare_stock') }}
                </ui5-label>
                <ui5-input
                    type="Text"
                    name="spareStock"
                    id="spareStock"
                />
            </div>

            <div
                id="editLoonlakwerkactive"
                class="field"
                v-show="false"
            >
                <ui5-label for="active">
                    {{ trans('pages.add_loonlakwerk.active') }}
                </ui5-label>
                <ui5-checkbox
                    name="active"
                    id="active"
                />
            </div>
            <div
                id="editLoonlakwerkprosite"
                class="field"
                v-show="false"
            >
                <ui5-label for="prosite">
                    {{ trans('pages.add_loonlakwerk.prosite_mm') }}
                </ui5-label>
                <ui5-checkbox
                    name="prosite"
                    id="prosite"
                />
            </div>
            <div
                id="editLoonlakwerkprositeEosol"
                class="field"
                v-show="false"
            >
                <ui5-label for="prositeEosol">
                    {{ trans('pages.add_loonlakwerk.prosite_eosol') }}
                </ui5-label>
                <ui5-checkbox
                    name="prositeEosol"
                    id="prositeEosol"
                />
            </div>
            <div
                id="editLoonlakwerkwebshop"
                class="field"
                v-show="false"
            >
                <ui5-label for="webshop">
                    {{ trans('pages.add_loonlakwerk.active_webshop') }}
                </ui5-label>
                <ui5-checkbox
                    name="webshop"
                    id="webshop"
                />
            </div>
        </div>
    </div>
</template>
<script>
import profileApi from '../api/profile';
import supplierApi from '../api/supplier';
import SpinnerText from '../components/loader/SpinnerText';
import Spinner from '../components/loader/Spinner';
import { showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    components: { Spinner, SpinnerText },
    mixins: [localization],
    mounted() {
        const promises = [
            profileApi.fetchAllProfileGroups().then((response) => {
                this.profileGroups = response.data.data;
            }),

            profileApi.fetchAllProfileSubGroups().then((response) => {
                this.profileSubgroups = response.data.data;
            }),

            supplierApi.fetchAllSuppliers().then((response) => {
                this.suppliers = response.data.data;
            }),

            profileApi.fetchNextLoonlakwerkNr().then((response) => {
                const el = window.document.querySelector('#code');
                el.value = response.data.data;
            }),
        ];
        this.loading = true;
        Promise.all(promises).then(() => {
            this.loading = false;
        });
    },
    data() {
        return {
            loading: false,
            saving: false,
            profileGroups: [],
            profileSubgroups: [],
            suppliers: [],
        };
    },
    methods: {
        getPayload() {
            const payload = {};
            payload.code = window.document
                .querySelector('#editLoonlakwerkcode')
                .querySelector('ui5-input').value;
            payload.groupRef = getSelectedOption(
                window.document
                    .querySelector('#editLoonlakwerkprofilegroup')
                    .querySelector('ui5-select')
            );
            payload.subgroupRef = getSelectedOption(
                window.document
                    .querySelector('#editLoonlakwerkprofilesubgroup')
                    .querySelector('ui5-select')
            );
            payload.stockgroupRef =
                getSelectedOption(
                    window.document
                        .querySelector('#editLoonlakwerkprofilestockgroup')
                        .querySelector('ui5-select')
                ) || '';
            payload.unitRef =
                getSelectedOption(
                    window.document
                        .querySelector('#editLoonlakwerkprofileunit')
                        .querySelector('ui5-select')
                ) || '';
            payload.supplierRef = getSelectedOption(
                window.document
                    .querySelector('#editLoonlakwerkprofilesupplier')
                    .querySelector('ui5-select')
            );
            payload.barcode = window.document
                .querySelector('#editLoonlakwerkbarcode')
                .querySelector('ui5-input').value;
            payload.description = window.document
                .querySelector('#editLoonlakwerkdescription')
                .querySelector('ui5-input').value;
            payload.descriptionFR = window.document
                .querySelector('#editLoonlakwerkdescriptionFR')
                .querySelector('ui5-input').value;
            payload.info = window.document
                .querySelector('#editLoonlakwerkinfo')
                .querySelector('ui5-input').value;
            payload.supplierId = '';
            payload.supplierCode = window.document
                .querySelector('#editLoonlakwerksupplierCode')
                .querySelector('ui5-input').value;
            payload.supplierProfileCode = window.document
                .querySelector('#editLoonlakwerksupplierProfileCode')
                .querySelector('ui5-input').value;
            payload.minStock = window.document
                .querySelector('#editLoonlakwerkminStock')
                .querySelector('ui5-input').value;
            payload.maxStock = window.document
                .querySelector('#editLoonlakwerkmaxStock')
                .querySelector('ui5-input').value;
            payload.currentstockcount = window.document
                .querySelector('#editLoonlakwerkcurrentstockcount')
                .querySelector('ui5-input').value;
            payload.packagePerUnit = window.document
                .querySelector('#editLoonlakwerkpackagePerUnit')
                .querySelector('ui5-input').value;
            payload.keepStock = window.document
                .querySelector('#editLoonlakwerkkeepStock')
                .querySelector('ui5-checkbox').checked
                ? 1
                : 0;
            payload.countsequence = window.document
                .querySelector('#editLoonlakwerkcountsequence')
                .querySelector('ui5-input').value;
            payload.location = window.document
                .querySelector('#editLoonlakwerklocation')
                .querySelector('ui5-input').value;
            payload.bruto = window.document
                .querySelector('#editLoonlakwerkbruto')
                .querySelector('ui5-input').value;
            payload.netto = window.document
                .querySelector('#editLoonlakwerknetto')
                .querySelector('ui5-input').value;
            payload.mmPrice = window.document
                .querySelector('#editLoonlakwerkmmPrice')
                .querySelector('ui5-input').value;
            payload.eosolPrice = window.document
                .querySelector('#editLoonlakwerkeosolPrice')
                .querySelector('ui5-input').value;
            payload.eosolBuyPrice = window.document
                .querySelector('#editLoonlakwerkeosolBuyPrice')
                .querySelector('ui5-input').value;
            payload.price4 = window.document
                .querySelector('#editLoonlakwerkprice4')
                .querySelector('ui5-input').value;
            payload.weightBox = window.document
                .querySelector('#editLoonlakwerkweightBox')
                .querySelector('ui5-input').value;
            payload.countPerKg = window.document
                .querySelector('#editLoonlakwerkcountPerKg')
                .querySelector('ui5-input').value;
            payload.latestPriceControl = ''; //Always hidden
            payload.pricelist = window.document
                .querySelector('#editLoonlakwerkpricelist')
                .querySelector('ui5-checkbox').checked
                ? 1
                : 0;
            payload.prosite = window.document
                .querySelector('#editLoonlakwerkprosite')
                .querySelector('ui5-checkbox').checked
                ? 1
                : 0;
            payload.weight = window.document
                .querySelector('#editLoonlakwerkweight')
                .querySelector('ui5-input').value;
            payload.length = window.document
                .querySelector('#editLoonlakwerklength')
                .querySelector('ui5-input').value;
            payload.height = window.document
                .querySelector('#editLoonlakwerkheight')
                .querySelector('ui5-input').value;
            payload.width = window.document
                .querySelector('#editLoonlakwerkwidth')
                .querySelector('ui5-input').value;
            payload.contour = window.document
                .querySelector('#editLoonlakwerkcontour')
                .querySelector('ui5-input').value;
            payload.contour2 = window.document
                .querySelector('#editLoonlakwerkcontour2')
                .querySelector('ui5-input').value;
            payload.weightLM = window.document
                .querySelector('#editLoonlakwerkweightLM')
                .querySelector('ui5-input').value;
            payload.roundToLength = '';
            payload.minLengthToRound = '';
            payload.isPart = 0;
            payload.location2 = window.document
                .querySelector('#editLoonlakwerklocation2')
                .querySelector('ui5-input').value;
            payload.binLocation = window.document
                .querySelector('#editLoonlakwerkbinlocation')
                .querySelector('ui5-input').value;
            payload.descriptionKanban = window.document
                .querySelector('#editLoonlakwerkdescriptionkanban')
                .querySelector('ui5-input').value;
            payload.deliveryPeriod = window.document
                .querySelector('#editLoonlakwerkdeliveryperiod')
                .querySelector('ui5-input').value;
            payload.spareStock = window.document
                .querySelector('#editLoonlakwerksparestock')
                .querySelector('ui5-input').value;
            payload.active = window.document
                .querySelector('#editLoonlakwerkactive')
                .querySelector('ui5-checkbox').checked
                ? 1
                : 0;
            payload.prositeEosol = window.document
                .querySelector('#editLoonlakwerkprositeEosol')
                .querySelector('ui5-checkbox').checked
                ? 1
                : 0;
            payload.webshop = window.document
                .querySelector('#editLoonlakwerkwebshop')
                .querySelector('ui5-checkbox').checked
                ? 1
                : 0;
            return payload;

            function getSelectedOption(selector) {
                return selector.selectedOption
                    ? selector.selectedOption.value
                    : null;
            }
        },
        save() {
            this.saving = true;
            profileApi
                .update(this.getPayload())
                .then(() => {
                    this.$router.push('/stockcount');
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans('pages.add_loonlakwerk.error_saving')
                    );
                })
                .finally(() => {
                    this.saving = false;
                });
        },
    },
};
</script>
